/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseLong } from '../../models/api-response-long';
import { OrderFilterRequest } from '../../models/order-filter-request';

export interface GetCount$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: OrderFilterRequest
}

export function getCount(http: HttpClient, rootUrl: string, params: GetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLong>> {
  const rb = new RequestBuilder(rootUrl, getCount.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseLong>;
    })
  );
}

getCount.PATH = '/v1/api/orders/order-count';
